import { usePage } from '@inertiajs/react';
import { uniqBy } from 'lodash';

import type { SharedProps } from '@/types';

export function useAccountOrganizations() {
  const { current_account: currentAccount } = usePage<SharedProps>().props;

  return uniqBy(
    (currentAccount?.authorizations ?? []).map((authorization) => authorization.organization),
    'id',
  );
}
